export default "/images/2fa21ae943877618a2b243e335e5f61b.avif";